(() => {
  if (window.sfxMobileSearchViewport) return;
  window.sfxMobileSearchViewport = true;
  const root = document.documentElement;
  const viewport = window.visualViewport;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    root.style.setProperty('--sfx-search-viewport-height', `${Math.round(viewport ? viewport.height : window.innerHeight)}px`);
    root.style.setProperty('--sfx-search-viewport-top', `${Math.round(viewport ? viewport.offsetTop : 0)}px`);
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(update);
    }
  };
  window.addEventListener('resize', schedule, { passive: true });
  if (viewport) {
    viewport.addEventListener('resize', schedule, { passive: true });
    viewport.addEventListener('scroll', schedule, { passive: true });
  }
  update();
})();
